import { Http } from "@/util";

export function sendSimpleNotice(params) {
  return Http.post(`/admin/notice/send_simple_notice`, params);
}

/**
 * 工作流等：仅拉取一条通知发送记录（NoticeRecord），用于正文/标题预览。
 */
export function getNoticeSendingRecordRecord(id, opts = {}) {
  return Http.get(`/admin/notice/sending-records/${id}/record`, opts);
}

/**
 * 发送记录页「数据」：各接收方阅读/确认明细 + Mongo 模板。
 */
export function getNoticeSendingRecordReadDetails(id) {
  return Http.get(`/admin/notice/sending-records/${id}/read-details`);
}
